import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { Select2 } from "select2-react-component";
import NumberFormat from 'react-number-format';
import SelectAsync from 'react-select/async';
export default class Stuff extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        };
    }
     
    componentDidMount() {
        this.httpPost("api/v1/stuff/get", {
            id: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    save(e) {    
        e.preventDefault();
        this.httpPost("api/v1/stuff/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            name: this.state.data.record.name,
            unitId: this.state.data.record.unitId,
            taxNumber: this.state.data.record.taxNumber,
            price: parseInt(this.state.data.record.price),
            taxRate: parseInt(this.state.data.record.taxRate),
            wage: parseInt(this.state.data.record.wage),
            rightOfAction: parseInt(this.state.data.record.rightOfAction),
            profit: parseInt(this.state.data.record.profit),
            discountPercent: parseInt(this.state.data.record.discountPercent),
            status: this.state.data.record.status,

        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.setState({
                    redirect: '/stuffs'
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    inquery(e) {
        this.httpPost("api/v1/common/getestuffcode", {
            companyId: this.state.data.global.company.id,
            code: this.state.data.record.taxNumber
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("استعلام انجام پذیرفت");
                this.state.data.record.name = data.record.vat;
                this.state.data.record.taxRate = data.record.descriptionOfID;
                this.setState({
                    loading: false,
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    loadStuffsUnit(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getunit/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status === 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                           
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    changeStatus(checked) {
        this.state.data.record.status = checked;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return<div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <div className="components-preview wide-md mx-auto">
                                    <div className="nk-block-head nk-block-head-lg wide-sm">
                                        <div className="nk-block-head-content">
                                    <div className="nk-block-head-sub">
                                        <a className="back-to" href="/stuffs/"><em className="icon ni ni-arrow-left"></em><span>فهرست کالاها/خدمات</span></a>
                                             </div>
                                        </div>
                                    </div>
									<div className="nk-block nk-block-lg">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-head">
                                                    <h5 className="card-title">اطلاعات کالا / خدمت</h5>
                                        </div>
                                        <br />
                                        <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                        
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <div className="custom-control custom-switch">
                                                            <input type="checkbox" className="custom-control-input" id="customSwitch2" onChange={e => this.changeStatus(e.target.checked)} defaultChecked={this.state.data.record.status} />
                                                            <label className="custom-control-label" htmlFor="customSwitch2"> کالای مربوط به طلا جواهر </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <br />
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">شرح کالا/خدمت</label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control" type="text" defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">شناسه کالا/خدمت</label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control" type="text" defaultValue={this.state.data.record.taxNumber} onChange={e => this.state.data.record.taxNumber = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">واحد اندازه گیری</label>
                                                        <div className="form-control-wrap">
                                                            <SelectAsync style={{ "width": "300px" }}
                                                                defaultValue={this.state.data.record.unitId > 0 ? [{ value: this.state.data.record.unitId, label: '' }] : null}
                                                                isMulti={false}
                                                                placeholder="انتخاب کالا/خدمت"
                                                                defaultOptions

                                                                loadOptions={this.loadStuffsUnit}
                                                                onChange={e => this.state.data.record.unitId = parseInt(e.value)}
                                                            />
                                                            {/*<select className="form-control" type="text" defaultValue={this.state.data.record.unitId} onChange={e => this.state.data.record.unitId = parseInt(e.target.value)}>*/}
                                                            {/*    <option value='0'>انتخاب نمایید...</option>*/}
                                                            {/*    {this.state.data.units.map(record =>*/}
                                                            {/*        <option value={record.id}>{record.name}</option>*/}
                                                            {/*    )}*/}
                                                            {/*</select>*/}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">مبلغ هر واحد(ریال)</label>
                                                        <div className="form-control-wrap">
                                                            <NumberFormat className="form-control" type="text" thousandSeparator={true} defaultValue={this.state.data.record.price} onChange={e => this.state.data.record.price = e.target.value.replace(/,/g, '')} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">نرخ ارزش افزوده</label>
                                                        <div className="form-control-wrap">
                                                            <input maxLength="2" className="form-control" type="text" defaultValue={this.state.data.record.taxRate} onChange={e => this.state.data.record.taxRate = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>
                                               
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">درصد محاسبه تخفیف</label>
                                                        <div className="form-control-wrap">
                                                            <input maxLength="2" className="form-control" type="text" defaultValue={this.state.data.record.discountPercent} onChange={e => this.state.data.record.discountPercent = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.data.record.status === true &&
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد محاسبه اجرت</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="2" className="form-control" type="text" defaultValue={this.state.data.record.wage} onChange={e => this.state.data.record.wage = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد محاسبه حق العمل</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="2" className="form-control" type="text" defaultValue={this.state.data.record.rightOfAction} onChange={e => this.state.data.record.rightOfAction = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد محاسبه سود</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="2"  className="form-control" type="text" defaultValue={this.state.data.record.profit} onChange={e => this.state.data.record.profit = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                           
                                                </div>
                                            
                                            
                                            }
                                 
                                            <br />
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-lg btn-primary">ثبت</button>
                                                    <a className="hand btn btn-lg btn-warning" style={{ "marginRight": '10px' }} onClick={e => this.inquery()}>استعلام</a>
                                                </div>
                                            </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}